// import Title from "./Title";

function Section({ name, children }) {
  return (
    <div className="px-2 w-full ">
      <div className="flex flex-row items-center text-[#855C3A] gap-3 px-4 bg-main-light/20 py-2 rounded-lg">
        <div>
          <div className="h-6 w-1 md:h-8  bg-[#855C3A] rounded-md"></div>
        </div>
        <div className="text-lg md:text-2xl tracking-widest font-bold">
          {name}
        </div>
      </div>
      {children}
    </div>
  );
}

export default Section;
